import React from 'react';
import QuotesTable from '../QuotesTable';

export default function SupplierQuotesIndexPage() {
	return <QuotesTable handleQueryParams enableViews enableBannerMessages />;
}
